<template>
<div>
    <div class="hb"></div>
    <div class="win">        
        <img v-show="bgshow" src="/static/images/bg1.png" />
        <img v-show="!bgshow" src="/static/images/bg2.png" />
        <img v-if="isCurLevel>0" class="mms" src="/static/images/win1.png" />
        <img v-show="isCurLevel<=0" class="mms" :src="'/static/images/winno.png'" />
        <img v-show="randomPic==1 && isCurLevel<=0" class="mmsmsg" :src="'/static/images/winnomsg1.png'" />
        <img v-show="randomPic==2 && isCurLevel<=0" class="mmsmsg" :src="'/static/images/winnomsg2.png'" />
        <img v-show="randomPic==3 && isCurLevel<=0" class="mmsmsg" :src="'/static/images/winnomsg3.png'" />
        <img v-show="randomPic==4 && isCurLevel<=0" class="mmsmsg" :src="'/static/images/winnomsg4.png'" />
        <img v-show="randomPic==5 && isCurLevel<=0" class="mmsmsg" :src="'/static/images/winnomsg5.png'" />
        <img v-show="randomPic==6 && isCurLevel<=0" class="mmsmsg" :src="'/static/images/winnomsg6.png'" />
        <img v-show="randomPic==7 && isCurLevel<=0" class="mmsmsg" :src="'/static/images/winnomsg7.png'" />

        <div class="level" v-if="isCurLevel>0">
            <img :src="'/static/images/level'+isCurLevel+'.png'" />
        </div>        
        <div class="button" v-on:click="againto"></div>
    </div>
    
</div>

</template>
<script>
export default {
    props:["isCurLevel"],
    data() {
        return{
            bgshow: false,
            stop: false,
            randomPic: 1
        }
    },
    mounted() {
        this.randomPic = parseInt(7*Math.random())+1;
        this.init();        
    },
    methods: {
        
        init: function () {
            
            setTimeout(()=>{
                this.bgshow = !this.bgshow;
                this.init();
            },500)
        },
        //继续
        againto:function(){
            this.randomPic = parseInt(7*Math.random())+1;
            //调用父组件函数
            this.$emit("againparent","data");
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/win.vue